// extracted by mini-css-extract-plugin
export var content = "HeaderMinimal-module--content--f1c72";
export var headerinner = "HeaderMinimal-module--headerinner--56a9d";
export var headerouter = "HeaderMinimal-module--headerouter--24d32";
export var logowrappertop = "HeaderMinimal-module--logowrappertop--d82fd";